import React, { Component } from "react";
import { toast } from 'react-toastify';

import api from "../../services/api";

const ID_PAIS_BRASIL = 26;

class SelectEstados extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      value: '',
      error: ''
    };
    this.onChange = props.onChange;
  }

  static getDerivedStateFromProps(props, state) {
    if (props.idEstado !== state.value) {
      return {
        value: props.idEstado,
        error: props.error
      };
    }
    return null;
  }

  loadEstados = () => {
    const idPais = this.props.idPais ? this.props.idPais : ID_PAIS_BRASIL;
    api.get('/estados', { params: { idPais: idPais } })
      .then(response => {
        this.setState({ options: response.data.estados });
      })
      .catch(error => {
        toast.error(error.message);
      });
  };

  componentDidMount = () => {
    this.loadEstados();
  };

  handleChange = (event) => {
    event.preventDefault();
    const value = event.target.value;
    if (this.state.value !== value) {
      this.setState({ value: value }, this.onChange(this.props.name, value));
    }
  };

  render() {
    const { options, value, error } = this.state;

    return (
      <select
        value={value}
        onChange={this.handleChange}
        onBlur={this.handleChange}
        className={'custom-select' + (error ? ' is-invalid' : '')}
        required={this.props.required}
      >
        <option value=""></option>
        {options.map((e, i) => <option key={i} value={e.id}>{this.props.showUF ? e.uf : e.estado}</option>)}
      </select>
    )
  }
}

export default SelectEstados;
